
<template>
  <div class="card">
    <el-button
      type="text"
      class="goback"
      icon="el-icon-arrow-left"
      @click.native="goBack"
    ></el-button>
    <el-image
      v-if="session"
      class="avatar"
      width="40"
      height="40"
      :src="
        session
          ? session.covey_user
            ? session.covey_user.photo
            : defaultAvatar
          : defaultAvatar
      "
    ></el-image>
    <div class="name" v-if="session">
      <div class="realname">
        {{
          session ? (session.covey_user ? session.covey_user.realname : "") : ""
        }}
      </div>
      <!-- <div class="desc">French teacher</div> -->
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      // 当前"我"的信息
      // 过滤后的会话列表
      session: (state) => state.chat.session,
      defaultAvatar: (state) => state.app.defaultAvatar,
    }),
  },
  methods: {
    goBack() {
      // window.history.back()
      this.$router.back(-1);
    },
  },
};
</script>
<style scoped lang="scss">
.card {
  padding: 0 16px;
  border-bottom: solid 1px #edecec;
  box-sizing: border-box;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  .goback {
    color: #f48c06;
    margin-right: 10px;
  }
  footer {
    margin-top: 10px;
  }
  .avatar,
  .name {
    vertical-align: middle;
  }
  .avatar {
    width: 40px;
    height: 40px;
    background: #d8d8d8;
    border-radius: 50%;
  }
  .name {
    margin-left: 12px;
    box-sizing: border-box;
    font-size: 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    font-weight: 600;
    font-family: PingFangSC-Semibold, PingFang SC;
    .realname {
      color: #201002;
    }
    .desc {
      color: #f48c06;
    }
  }

  .search {
    padding: 0 10px;
    // width: 100%;
    font-size: 12px;
    color: #fff;
    height: 30px;
    line-height: 30px;
    border: solid 1px #3a3a3a;
    border-radius: 4px;
    outline: none;
    background-color: #26292e;
  }
}
</style>